// These are build-time technical fallbacks only.
// Runtime product and rollout flags should come from cms-api `/api/feature-flags/v1/bootstrap`.
export const ENABLE_TRUD = false;
export const ENABLE_NHS_TERMINOLOGY = true;
